// extracted by mini-css-extract-plugin
export default {"cls1":"VeloModalSheetHeader-Header_cls1__+G-uO","cls2":"VeloModalSheetHeader-Header_cls2__zIw2k VeloModalSheetHeader-Header_cls1__+G-uO"};